import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import { Form, message } from 'antd';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { submitForm } from '../../redux/actions/submit';
import { uploadOneFile, uploadFileContact } from '../../redux/actions/upload';
import MetaSeo from '../MetaSeo';
import { toast, ToastContainer } from 'react-nextjs-toast';

import {
  validateEmailWithoutSpecial,
  validatePhoneNumber,
  trimText,
} from '../../lib/common';
const formRef = React.createRef();
import useTrans from '../../hooks/useTrans';
import _ from 'lodash';

export default function Contact(props) {
  const dispatch = useDispatch();
  const fileref = useRef(null);
  const [fileupload, setFile] = useState(null);
  const trans = useTrans();
  const onDelaySubmit = _.debounce(() => OnSubmit(), 1000);
  const OnSubmit = async () => {
    await formRef.current.validateFields();
    let {
      name,
      email,
      mobile,
      title,
      note,
      purpose,
    } = formRef.current.getFieldsValue();
    let image = '';
    let checkFile = false;
    if (fileupload) {
      let newUploadFile = new FormData();
      newUploadFile.append('file', fileupload);
      image = await uploadFileContact(newUploadFile);
      if (image === undefined) {
        checkFile = true;
        window.alert('Lỗi khi upload file');
      }
    }
    let dataPush = {
      name,
      email,
      mobile,
      title,
      note,
      url: image,
      other_data: { purpose },
      type: 'contact',
    };
    if (checkFile === false) {
      const res = await submitForm(dataPush);
      if (res.code !== 200) {
        // toast.notify(`${res.message}`, {
        //   duration: 5,
        //   type: 'error',
        //   title: 'Có lỗi xảy ra',
        // });
        window.alert('Có lỗi xảy ra');
      } else {
        // toast.notify('Thành công', {
        //   duration: 120,
        //   type: 'success',
        //   title: 'Đã gửi thành công',
        // });
        window.alert('Đã gửi thành công');
        formRef.current.resetFields();
        fileref.current.files = null;
        setFile(null);
      }
    }
    setTimeout(() => {
      toast.remove();
    }, 3000);
  };
  const regexPhoneNumber = /^((\+)84|0)[1-9](\d{2}){4}$/;

  const trimInput = (key, e) => {
    let { value } = e.target;
    formRef.current.setFieldsValue({ [key]: value.trim() });
  };
  const dataSeo = {
    title: `${`${trans.layout.contact}`} | EYEFIRE`,
    description: trans.seo.contact.description,
  };
  return (
    <>
      <MetaSeo {...dataSeo} />
      <div className="main-content">
        <section className="p-contact">
          <div className="p-contact__main">
            <div className="l-container">
              <ToastContainer position={'top'} />
              <div className="l-row">
                <div className="l-col l-col__info">
                  <div className="c-title">
                    <h3>{trans.layout.title_contact}</h3>
                    <p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: trans.layout.content_contact1,
                        }}
                      ></div>
                      {trans.layout.content_contact2}
                    </p>
                  </div>
                  <div className="p-contact__keep">
                    <div className="p-contact__title">
                      <h3 data-aos="fade-up">{trans.contact_now}</h3>
                    </div>
                    <div className="p-contact__keep__content vnhwqyhaf">
                      <ul>
                        <li>
                          <a
                            className="update_contact_a"
                            href="tel:+84 24 3910 2030"
                          >
                            <img src="/assets/images/home/phone_u.svg" alt="" />
                            <span>+84 24 3910 2030</span>
                          </a>
                        </li>

                        <li>
                          <a
                            className="update_contact_a"
                            href="mailto:info@eyefire.vn"
                          >
                            <img src="/assets/images/home/mail_u.svg" alt="" />
                            <span>info@eyefire.vn</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="p-contact__keep">
                    <div className="p-contact__title">
                      <h3>{trans.layout.keep}</h3>
                    </div>
                    <div className="p-contact__keep__content">
                      {/* <ul>
                        <li>
                          <a href='https://www.facebook.com/EyeFireCorp' target='_blank'>
                            <img
                              src='./assets/img/common/icn_fb-footer.svg'
                              alt=''
                            />
                          </a>
                        </li>
                        <li>
                          <a href='#'>
                            <img src='./assets/img/common/icn_mes.svg' alt='' />
                          </a>
                        </li>
                        <li>
                          <a href='#'>
                            <img src='./assets/img/common/icn_sky.svg' alt='' />
                          </a>
                        </li>
                        <li>
                          <a href='#'>
                            <img src='./assets/img/common/icn_in.svg' alt='' />
                          </a>
                        </li>
                        <li>
                          <a href='#'>
                            <img src='./assets/img/common/icn_tw.svg' alt='' />
                          </a>
                        </li>
                      </ul> */}

                      <ul>
                        <li>
                          <a
                            href="https://www.facebook.com/EyeFireCorp"
                            target={'_blank'}
                          >
                            <svg
                              width="33"
                              height="33"
                              viewBox="0 0 33 33"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16.5"
                                cy="16.5"
                                r="16.5"
                                fill="white"
                              />
                              <path
                                d="M20.1116 10.2951H21.9233V7.13974C21.6107 7.09674 20.5358 7 19.2839 7C16.6718 7 14.8825 8.643 14.8825 11.6627V14.4419H12V17.9693H14.8825L14.8825 26.845H18.4165V17.9701H21.1824L21.6215 14.4427H18.4157V12.0125C18.4165 10.993 18.6911 10.2951 20.1116 10.2951Z"
                                fill="#000E33"
                              />
                            </svg>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.linkedin.com/company/tcom-corporation"
                            target={'_blank'}
                          >
                            <svg
                              width="33"
                              height="33"
                              viewBox="0 0 33 33"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_484_14501)">
                                <path
                                  d="M16.4999 0C25.6131 0 33 7.38787 33 16.5001C33 25.6122 25.6131 33 16.4999 33C7.38674 33 0 25.6121 0 16.5001C0 7.38798 7.38685 0 16.4999 0Z"
                                  fill="white"
                                />
                                <path
                                  d="M9.29779 22.671H12.3874V12.3729H9.29779V22.671ZM21.3346 12.0162C19.8351 12.0162 18.4935 12.5637 17.5417 13.7724V12.339H14.4407V22.6711H17.5417V17.0837C17.5417 15.9029 18.6235 14.751 19.9785 14.751C21.3336 14.751 21.6677 15.9029 21.6677 17.0549V22.67H24.7574V16.8249C24.7573 12.7648 22.8351 12.0162 21.3346 12.0162ZM10.8282 11.3437C11.6821 11.3437 12.3751 10.6507 12.3751 9.79681C12.3751 8.94292 11.6821 8.25 10.8282 8.25C9.97428 8.25 9.28125 8.94303 9.28125 9.79692C9.28125 10.6508 9.97428 11.3437 10.8282 11.3437Z"
                                  fill="#000E33"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_484_14501">
                                  <rect width="33" height="33" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.youtube.com/@EyeFireCorp"
                            target={'_blank'}
                          >
                            <svg
                              width="33"
                              height="33"
                              viewBox="0 0 33 33"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16.5"
                                cy="16.5"
                                r="16.5"
                                fill="white"
                              />
                              <path
                                d="M24.6452 12.8745C24.5484 12.5115 24.3587 12.1805 24.095 11.9146C23.8313 11.6487 23.5028 11.4572 23.1425 11.3592C21.8163 11 16.5 11 16.5 11C16.5 11 11.1837 11 9.85748 11.3573C9.49703 11.4549 9.16842 11.6463 8.90465 11.9123C8.64089 12.1783 8.45126 12.5095 8.3548 12.8726C8 14.2102 8 17 8 17C8 17 8 19.7898 8.3548 21.1255C8.55022 21.8631 9.12701 22.4439 9.85748 22.6408C11.1837 23 16.5 23 16.5 23C16.5 23 21.8163 23 23.1425 22.6408C23.8749 22.4439 24.4498 21.8631 24.6452 21.1255C25 19.7898 25 17 25 17C25 17 25 14.2102 24.6452 12.8745ZM14.8114 19.5605V14.4395L19.2132 16.9809L14.8114 19.5605Z"
                                fill="#000E33"
                              />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="p-contact__office">
                    <div className="p-contact__title">
                      <h3>{trans.layout.office}</h3>
                    </div>
                    <div className="p-contact__office__content">
                      <ul>
                        <li>
                          <h3>{trans.layout.adrHn}</h3>
                          <p>
                            <div
                              className="p-contact__address"
                              dangerouslySetInnerHTML={{
                                __html: trans.layout.address1,
                              }}
                            ></div>
                            <div className="mapView">
                              <a
                                className="p-contact__office__handle-btn"
                                target="_blank"
                                href="https://www.google.com/maps/place/Ng.+19+%C4%90.+Nguy%E1%BB%85n+Tr%C3%A3i,+Kh%C6%B0%C6%A1ng+Trung,+%C4%90%E1%BB%91ng+%C4%90a,+H%C3%A0+N%E1%BB%99i/@21.0022651,105.8203236,17z/data=!3m1!4b1!4m5!3m4!1s0x3135ac84f6869bf1:0xd2a5ff274402a0a0!8m2!3d21.0022651!4d105.8203236?hl=en"
                              >
                                <span>Map View</span>
                                <img src="./assets/img/common/icn_next-contact.svg" />
                              </a>
                            </div>
                          </p>
                        </li>

                        <li>
                          <h3>{trans.layout.adrHcm}</h3>
                          <p>
                            <div
                              className="p-contact__address"
                              dangerouslySetInnerHTML={{
                                __html: trans.layout.address2,
                              }}
                            ></div>
                            <div className="mapView">
                              <a
                                className="p-contact__office__handle-btn"
                                target="_blank"
                                href="https://www.google.com/maps/place/17+H%E1%BB%93+V%C4%83n+Hu%C3%AA,+Ph%C6%B0%E1%BB%9Dng+9,+Ph%C3%BA+Nhu%E1%BA%ADn,+H%E1%BB%93+Ch%C3%AD+Minh+70022,+Vi%E1%BB%87t+Nam/@10.8013743,106.6729851,17z/data=!3m1!4b1!4m6!3m5!1s0x3175292807e7e625:0x1f789038895ceb8d!8m2!3d10.801369!4d106.67556!16s%2Fg%2F11hjkqgthr?hl=vi-VN&entry=ttu&g_ep=EgoyMDI0MTAwOS4wIKXMDSoASAFQAw%3D%3D"
                              >
                                <span>Map View</span>
                                <img src="./assets/img/common/icn_next-contact.svg" />
                              </a>
                            </div>
                          </p>
                        </li>
                        <li>
                          <h3>{trans.layout.adrJp}</h3>
                          <p>
                            <div
                              className="p-contact__address"
                              dangerouslySetInnerHTML={{
                                __html: trans.layout.address3,
                              }}
                            ></div>
                            <div className="mapView">
                              <a
                                className="p-contact__office__handle-btn"
                                target="_blank"
                                href="https://www.google.co.jp/maps/place/THE+HUB+%E7%AB%8B%E5%B7%9D+nex+Inc./@35.6959613,139.4119304,17z/data=!3m2!4b1!5s0x6018e17b0d34626d:0x689d36f4af787ff0!4m5!3m4!1s0x6018e174c9931d8b:0x55275e3f4e298915!8m2!3d35.6959613!4d139.4119304"
                              >
                                <span>Map View</span>
                                <img src="./assets/img/common/icn_next-contact.svg" />
                              </a>
                            </div>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="l-col l-col__form">
                  {/* <form ref={formRef}>
                    <div className='p-contact__form'>
                      <input type='text' placeholder='Nguyễn Văn A' />
                    </div>

                    <div className='p-contact__form'>
                      <input type='text' placeholder='Work email' />
                    </div>

                    <div className='p-contact__form'>
                      <input type='text' placeholder='Số điện thoại' />
                    </div>

                    <div className='p-contact__form'>
                      <input type='text' placeholder='Tiêu đề' />
                    </div>
                    <div className='p-contact__form'>
                      <select name='' id=''>
                        <option value='' disabled hidden selected>
                          Mục đích liên hệ
                        </option>
                        <option value='demo'>demo</option>
                        <option value='demo'>demo</option>
                      </select>
                    </div>
                    <div className='p-contact__form'>
                      <textarea
                        name=''
                        id=''
                        cols='30'
                        rows='10'
                        placeholder='Nội dung liên hệ'
                      ></textarea>
                    </div>
                    <div className='p-contact__form'>
                      <label className='filelabel'>
                        <span className='title'>
                          <img
                            src='./assets/img/common/icn_up-load-file.svg'
                            alt=''
                          />
                          File đính kèm
                        </span>
                        <input
                          className='FileUpload1'
                          id='FileInput'
                          name='booking_attachment'
                          type='file'
                          value=''
                        />
                      </label>
                    </div>
                    <div className='p-contact__form'>
                      <button className='c-btn' onClick={(e) => {
                        e.preventDefault()
                        onDelaySubmit()
                      }}>{trans.layout.btn_send}</button>
                    </div>
                  </form> */}
                  <Form ref={formRef} style={{ overflow: 'hidden' }}>
                    <div className="form-group p-contact__form">
                      <Form.Item
                        name="name"
                        rules={[
                          { required: true, message: 'Vui lòng nhập tên!' },
                        ]}
                      >
                        <input
                          type="text"
                          onBlur={e => trimInput('name', e)}
                          c
                          className="form-control"
                          placeholder={trans.contact.form_name}
                        />
                      </Form.Item>
                    </div>
                    <div className="form-group p-contact__form">
                      <Form.Item
                        name="email"
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value || value.trim() === '') {
                                return Promise.reject('Vui lòng nhập email!');
                              }
                              if (!validateEmailWithoutSpecial(value)) {
                                return Promise.reject(
                                  'Vui lòng nhập email đúng định dạng!',
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <input
                          className="form-control"
                          onBlur={e => trimInput('email', e)}
                          placeholder={trans.contact.form_mail}
                        />
                      </Form.Item>
                    </div>
                    <div className="form-group p-contact__form mb-0">
                      <Form.Item
                        name="mobile"
                        rules={[
                          // { required: true, message: 'Vui lòng điền số điện thoại!' },
                          {
                            validator: (_, value) => {
                              if (!value || value.trim() === '') {
                                return Promise.reject(
                                  'Vui lòng nhập số điện thoại!',
                                );
                              }
                              if (value && isNaN(value)) {
                                return Promise.reject(
                                  'Vui lòng nhập định dạng số!',
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <input
                          className="form-control"
                          placeholder={trans.contact.form_phone}
                        />
                      </Form.Item>
                    </div>
                    <div className="form-group p-contact__form">
                      <Form.Item
                        name="title"
                        rules={[
                          { required: true, message: 'Vui lòng nhập tiêu đề!' },
                        ]}
                      >
                        <input
                          type="text"
                          onBlur={e => trimInput('title', e)}
                          className="form-control"
                          placeholder={trans.contact.form_subject}
                        />
                      </Form.Item>
                    </div>
                    <div className="form-group p-contact__form">
                      <Form.Item
                        name="purpose"
                        rules={[
                          {
                            required: true,
                            message: 'Vui lòng chọn mục đích!',
                          },
                        ]}
                      >
                        <select name id>
                          <option value="">{trans.contact.form_purpose}</option>
                          <option value="Báo giá">{trans.contact.form_quotation}</option>
                          <option value="Yêu cầu tư vấn">{trans.contact.form_request}</option>
                          <option value="Hợp tác">{trans.contact.form_cooperation}</option>
                          <option value="Khác">{trans.contact.form_orther}</option>
                        </select>

                        {/* <input type='text' onBlur={(e) => trimInput('title', e)} className='form-control' placeholder='Mục đích liên hệ' /> */}
                      </Form.Item>
                    </div>
                    <div className="form-group p-contact__form">
                      <Form.Item
                        name="note"
                        rules={[
                          {
                            required: true,
                            message: 'Vui lòng nhập nội dung liên hệ!',
                          },
                        ]}
                      >
                        <textarea
                          onBlur={e => trimInput('note', e)}
                          className="form-control"
                          placeholder={trans.contact.form_message}
                        />
                      </Form.Item>
                    </div>
                    <div className="p-contact__form">
                      <label className="filelabel">
                        <span className="title">
                          <img
                            src="/assets/img/common/icn_up-load-file.svg"
                            alt=""
                          />
                          {fileupload?.name
                            ? fileupload?.name
                            : trans.contact.form_file}
                        </span>
                        <input
                          className="FileUpload1"
                          id="FileInput"
                          name="booking_attachment"
                          type="file"
                          ref={fileref}
                          onChange={e => {
                            setFile(e.target.files[0]);
                            // formRef.current.validateFields('');
                          }}
                          accept=".png,.jpg,.svg,.gif,.xls,.xlsx,.pdf,.doc,.docx,.webp,.jpeg"
                        />
                      </label>
                    </div>
                    <div className="p-contact__form c-button-submit">
                      <button
                        className="c-btn"
                        onClick={e => {
                          e.preventDefault();
                          onDelaySubmit();
                        }}
                      >
                        {trans.layout.btn_send}
                      </button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>

            <div className="p-contact__image-bg">
              <div className="l-container">
                {' '}
                <div className="c-title c-title--center">
                  <h3>{trans.office}</h3>
                </div>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3724.7596357608218!2d105.81813491548326!3d21.00227009405671!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135ac84f6869bf1%3A0xd2a5ff274402a0a0!2zTmcuIDE5IMSQLiBOZ3V54buFbiBUcsOjaSwgS2jGsMahbmcgVHJ1bmcsIMSQ4buRbmcgxJBhLCBIw6AgTuG7mWksIFZpZXRuYW0!5e0!3m2!1sen!2s!4v1669030545663!5m2!1sen!2s"
                  width={'100%'}
                  height={512}
                  style={{ border: 0 }}
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
